import Vue from 'vue'
import VueRouter from 'vue-router'
import getInitInfo from '@/utils/wxsdk.js'
import store from '@/store/index'
import config from '@/api/config'
Vue.use(VueRouter)
let routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/SendExpress/Home/index.vue'),
    meta: { title: '首页' }
  },
  {
    path: '/goFastMail',
    name: 'goFastMail',
    component: () => import('@/views/SendExpress/goFastMail/index.vue'),
    meta: { title: '寄件', config: true }
  },
  {
    path: '/certification',
    name: 'certification',
    component: () => import('@/views/SendExpress/certification/index.vue'),
    meta: { title: '实名认证' }
  },
  {
    path: '/senderInfo',
    name: 'senderInfo',
    component: () => import('@/views/SendExpress/senderInfo/index.vue'),
    meta: { title: '新增寄件人' }
  },
  {
    path: '/addresseeInfo',
    name: 'addresseeInfo',
    component: () => import('@/views/SendExpress/addresseeInfo/index copy.vue'),
    meta: { title: '新增收件人' }
  },
  {
    path: '/senderAddressBook',
    name: 'senderAddressBook',
    component: () => import('@/views/SendExpress/addressBook/sender/index.vue'),
    meta: { title: '寄件人地址簿' }
  },
  {
    path: '/addresseeAddressBook',
    name: 'addresseeAddressBook',
    component: () =>
      import('@/views/SendExpress/addressBook/addressee/index.vue'),
    meta: { title: '收件人地址簿' }
  },
  {
    path: '/allServicePoint',
    name: 'allServicePoint',
    component: () => import('@/views/SendExpress/allServicePoint/all.vue'),
    meta: { title: '全部服务点', config: true }
  },
  {
    path: '/chooseExpress',
    name: 'chooseExpress',
    component: () => import('@/views/SendExpress/chooseExpress/index.vue'),
    meta: { title: '选择快递' }
  },
  {
    path: '/orderDetail',
    name: 'orderDetail',
    component: () => import('@/views/SendExpress/orderDetail/index.vue'),
    meta: { title: '寄件详情' }
  },
  {
    path: '/fee/pay',
    name: 'pay',
    component: () => import('@/views/SendExpress/fee/pay.vue'),
    meta: { title: '订单支付', config: true }
  },
  {
    path: '/fee/paySuccess',
    name: 'paySuccess',
    component: () => import('@/views/SendExpress/fee/paySuccess.vue'),
    meta: { title: '支付成功', config: true }
  },
  {
    path: '/express/list',
    name: 'ExpressList',
    component: () => import('@/views/PickExpress/expressList/list.vue'),
    meta: { title: '取件列表', config: true }
  },
  {
    path: '/letterSetting',
    name: 'letterSetting',
    component: () => import('@/views/letterSetting/index.vue'),
    meta: { title: '信包设置' }
  },
  {
    path: '/letterSetting/edit',
    name: 'editLetterPassword',
    component: () => import('@/views/letterSetting/edit.vue'),
    meta: { title: '修改取信密码' }
  },
  {
    path: '/download',
    name: 'download',
    component: () => import('@/views/download/index.vue'),
    meta: { title: 'APP下载' }
  },
  {
    path: '/report/data',
    name: 'reportSite',
    component: () => import('@/views/report/BI.vue'),
    meta: { title: '数据统计' }
  },
  {
    path: '/report/nxDataCab',
    name: 'reportCab',
    component: () => import('@/views/report/data_nanxunCab.vue'),
    meta: { title: '快递柜数据统计' }
  },
  {
    path: '/sms/index',
    name: 'sms',
    component: () => import('@/views/sms/index.vue'),
    meta: { title: '验证码获取' }
  }
]
if (config.env === false) {
  const rou = [
    {
      path: '/location',
      name: 'location',
      component: () => import('@/views/SendExpress/location/index copy.vue'),
      meta: { title: '获取坐标' }
    }
  ]
  routes = routes.concat(rou)
}
const router = new VueRouter({
  mode: 'history',
  routes
})

const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err)
}
router.beforeEach((to, from, next) => {
  store.commit('clearToken') // 取消请求
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title || '加载中'
  }
  if (to.meta.config) {
    let u = navigator.userAgent
    let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端 修复iOS版微信HTML5 History兼容性问题
    if (isiOS && to.path !== location.pathname) {
      // 此处不可使用location.replace
      location.assign(to.fullPath)
    } else {
      next()
    }
  } else {
    next()
  }
})
router.afterEach((to, from) => {
  if (to.meta.config) {
    store.commit('set_routerViewShow', false)
    store.commit('showLoading')
    getInitInfo(to.name)
  }
  if (document.documentElement.scrollTop) {
    document.documentElement.scrollTop = 0
  }
  if (document.body.scrollTop) {
    document.body.scrollTop = 0
  }
})
export default router
